export default class Setting {
    constructor(Rest) {
        this.rest = Rest.rest;
    }

    updateSenderDetail(attributes) {
        return this.rest.one('sender').post('details', attributes);
    };

    findSenderDetail() {
        return this.rest.one('sender').one('details').get();
    };

    changeUserPassword(oldPassword, newPassword) {
        return this.rest.one('user').post('password', {oldPassword: oldPassword, newPassword: newPassword});
    };

    createApiKey(name) {
        return this.rest.all('settings/apiKey').post({name: name});
    };

    allApiKeys() {
        return this.rest.all('settings/apiKey').getList();
    };

    getLanguage() {
        return this.rest.one('user').one('language').get();
    };

    setLanguage(key) {
        return this.rest.one('user').post('language', {language: key});
    };

    getAccountDetails() {
        return this.rest.one('account').one('details').get();
    };

    getWebhooks() {
        return this.rest.one('webhook').get();
    };

    getWebhookEvents() {
        return this.rest.one('webhook').one('events').get();
    };

    createWebhook(event, url) {
        return this.rest.all('webhook').post({eventId: event, url: url});
    };

    testCallWebhook(event) {
        return this.rest.all('webhook/test-call').post({event: event.data.code});
    };

    deleteWebhook(webHookId) {
        return this.rest.one('webhook', webHookId).remove();
    };

    updateWebhook(webhook) {
        return this.rest.all('webhook/' + webhook.id).customPUT({event: webhook.event, url: webhook.url});
    };

    getSitooCredentials() {
        return this.rest.one('settings/sitooCredentials').get();
    };

    createSitooCredentials(sitooAccountId, apiId, password) {
        return this.rest.all('settings/sitooCredentials').post({
            sitooAccountId: sitooAccountId,
            apiId: apiId,
            password: password
        });
    };

    deleteSitooCredentials(credentialsId) {
        return this.rest.one('settings/sitooCredentials', credentialsId).remove();
    };

    getPromoCodesGroups() {
        return this.rest.all('promo-codes').getList();
    };

    createPromoCodesGroup(name) {
        return this.rest.all('promo-code-types').post({name});
    }

    clearPromocodes(type_id) {
        return this.rest.one('promo-codes', type_id).remove();
    }

    deletePromocodesGroup(type_id) {
        return this.rest.one('promo-code-types', type_id).remove();
    }

    uploadPromoCodes(file, group) {
        let formData = new FormData();
        formData.append('file', file);
        formData.append('type', group);

        return this.rest.one('promo-codes/upload').withHttpConfig({transformRequest: angular.identity}).customPOST(
            formData,
            '',
            {},
            {'Content-Type': undefined}
        );
    };

    getCustomerNotificationsSettings() {
        return this.rest.one('customer-notifications-settings').get();
    }

    saveCustomerNotificationsSettings(settings) {
        if (typeof settings.emails === 'string' || settings.emails instanceof String) {
            settings.emails = settings.emails.split(',');
        }

        return this.rest.all('customer-notifications-settings').post(settings);
    }

}

Setting.$inject = ['Rest'];
